import { Box, IconButton, Paper, Stack, Typography } from "@mui/material";
import Delete from "@mui/icons-material/Delete";
import { PdfIcon } from "../../../../../../components/icons/PdfIcon";
import { DownloadIcon } from "../../../../../../components/icons";
import { useDocuments } from "../../../../view-booking/hooks/UseDocuments";
import { DocumentItem } from "../../../types/documents";

interface DocumentItemProps {
  document: DocumentItem;
  onDeleted?: (id: string) => void;
}

export default function DocumentItems({
  document,
  onDeleted,
}: DocumentItemProps) {
  const { handleViewDocument, handleDocumentDelete } = useDocuments();
  const getFileNameFromUrl = (url?: string) => {
    if (!url) return "";

    const cleanUrl = url.split("?")[0].split("#")[0];
    const parts = cleanUrl.split("/");
    return decodeURIComponent(parts[parts.length - 1] || "");
  };

  return (
    <Paper
      sx={{
        border: "1px solid #f0f4f8",
        borderRadius: "6px",
        p: 1.5,
        boxShadow: 0,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: 26,
            height: 30,
            bgcolor: "#fef2f2",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PdfIcon />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{ fontWeight: 600, fontSize: "14px", color: "text.secondary" }}
          >
            {document.name}
          </Typography>
          <Typography sx={{ fontWeight: 400, fontSize: "12px" }}>
            {getFileNameFromUrl(document.document_field)}
          </Typography>
        </Box>

        <Stack direction="row" spacing={1}>
          <IconButton
            size="small"
            onClick={() => handleViewDocument(document.document_field)}
          >
            <DownloadIcon sx={{ fontSize: 16 }} />
          </IconButton>

          <IconButton
            size="small"
            onClick={async () => {
              const ok = await handleDocumentDelete(String(document.id));
              if (ok) onDeleted?.(String(document.id));
            }}
          >
            <Delete sx={{ fontSize: 16 }} />
          </IconButton>
        </Stack>
      </Stack>
    </Paper>
  );
}
